import { config } from './configuration/config';
import {
    createEnvironmentSpecificConfig,
    createLoginConfig,
    resolveEnvironment,
} from './configuration/login/environmentUtils';
import { configureDatadogLogging } from './configuration/setup/datadog';

// prepare the environment / config stuff before we're doing ANYTHING
// (this gives time to e.g. the UIKIT autoloading the correct CSS based on the data-brand attribute)
const environment = resolveEnvironment(window.location.hostname);

config.environmentFromUri = environment;
config.environmentConfig = createEnvironmentSpecificConfig(environment);
config.login = createLoginConfig(environment);

configureDatadogLogging();

document.documentElement.dataset.brand = config.environmentConfig.brand;

const titleElement = document.createElement('title');
titleElement.innerText = config.environmentConfig.htmlTitle;
document.head.appendChild(titleElement);

// load all other things in an async fashion
import('./appBootstrap');
